import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const SalesOrderConversionRoute: RouteType = {
  name: "Sales Order Conversion",
  path: "/sales-order-conversion",
  layout: "/app",
  group: "Purchasing",
  requiresAuth: true,
  requiresPermission: false,
  hidden: true,
  viewportCard: {
    header: {
      title: "Sales Order Conversion",
      component: () => import("./SalesOrderConversionHeader"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./SalesOrderConversion"),
      grayBackground: true,
    },
  },
  dialogs: [],
  onEnter: async ({ rootStore }) => {
    try {
      // Load required data
      const accountsStore = rootStore.accountsStore as ServiceStore;
      const jobStore = rootStore.jobStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const quotesStore = rootStore.quotesStore as ServiceStore;
      const quoteLineItemsStore = rootStore.quoteLineItemsStore as ServiceStore;
      const salesOrdersStore = rootStore.salesOrdersStore as ServiceStore;
      const salesOrderLineItemsStore =
        rootStore.salesOrderLineItemsStore as ServiceStore;
      const castingMapLayoutStore =
        rootStore.castingMapLayoutStore as ServiceStore;

      // Load data if stores exist - use await to ensure data is loaded
      await Promise.all([
        accountsStore?.find(),
        jobStore?.find(),
        productsStore?.find(),
        quotesStore?.find(),
        quoteLineItemsStore?.find(),
        salesOrdersStore?.find(),
        salesOrderLineItemsStore?.find(),
        castingMapLayoutStore?.find(),
      ]);
    } catch (error) {
      console.error("Failed to load data for sales order conversion:", error);
    }
  },
};

export default SalesOrderConversionRoute;
